export default class PermissionDeniedError extends Error {
  static CODE = 'permission-denied'

  constructor(resource, id, action, message=`can't perform action '${action}' on ${resource.name || resource} #${id}`) {
    super(message)
    this.code = PermissionDeniedError.CODE
    this.resource = resource
    this.action = action
    this.id = id
  }
}
